import m from "../../../../geodata/es2015/region/usa/wiHigh";
window.am4geodata_region_usa_wiHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/wiHigh.js
// module id = null
// module chunks = 